import React from "react";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import { FormControlLabel } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";

export function ChildCheckbox({ filterState, colourState, handleChange }) {

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexGrow: 1,
        pl: "30px",
        overflowY: "auto",
        //   ...sx,
      }}
    >
      {Object.keys(filterState).map((name, index) => {
         return (
          <Box key={index}>
            <FormControlLabel
              label={name}
              control={
                <Checkbox
                  sx={{
                    color: colourState[name],
                    "&.Mui-checked": {
                      color: colourState[name],
                    },
                  }}
                  icon={<CircleOutlinedIcon />}
                  checkedIcon={<CircleIcon />}
                  checked={Boolean(filterState[name])}
                  onChange={(event) => handleChange(event, name)}
                />
              }
            />
          </Box>
        );
      })}
    </Box>
  );
}
